export default "__VITE_ASSET__5rIGW5nO__"